export var IMAGE_DROPZONE_DEFAULT_ICON_COLOR = 'grey-300';
export var IMAGE_DROPZONE_ACTIVE_ICON_COLOR = 'grey-700';
export var IMAGE_DROPZONE_ERROR_ICON_COLOR = 'ui-red';
export var UPLOAD_STATUS_UPLOADING = 'uploading';
export var UPLOAD_STATUS_SUCCESS = 'uploaded';
export var UPLOAD_STATUS_FAILED = 'failed';